<template>
    <CardRh :processando="processando">
        <div class="qts-dia-page">
            <section class="filter-panel" v-if="hasPermissaoEditar">
                <span class="panel-border-label">Adicionar dia</span>
                <div class="row g-4 align-items-end">
                    <div class="col-12 col-md-4">
                        <label class="form-label">Data</label>
                        <input type="date" class="form-control form-control-solid" v-model="novaData" />
                    </div>
                    <div class="col-12 col-md-3">
                        <button type="button" class="btn btn-pmes-primary btn-sm" @click="adicionar">
                            <i class="fa fa-plus"></i> Adicionar
                        </button>
                    </div>
                </div>
            </section>

            <section class="table-panel">
                <KDataTable :reload="reloadDatatable" :config="config" :pesquisar="false"
                    @tableatualizada="tableatualizada()">
                    <th style="max-width:90px">ID</th>
                    <th>Data</th>
                    <th style="min-width:130px" class="text-center" v-if="hasPermissaoEditar">Ações</th>
                </KDataTable>
            </section>
        </div>

        <div class="modal fade" :id="modal_editar" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog" style="max-width:500px;">
                <div class="modal-content">
                    <div class="modal-header">
                        <h2>Editar Dia</h2>
                        <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                            <span class="svg-icon svg-icon-1">
                                <inline-svg src="media/icons/duotone/Navigation/Close.svg" />
                            </span>
                        </div>
                    </div>
                    <div class="modal-body m-4">
                        <div class="form-group">
                            <label class="form-check-label">Data:</label>
                            <input type="date" class="form-control" v-model="editData" />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <BotaoSalvar @click="salvarEdicao" :processando="processando" titulo="Atualizar"></BotaoSalvar>
                    </div>
                </div>
            </div>
        </div>
        <button ref="abrirEditar" data-bs-toggle="modal" :data-bs-target="'#' + modal_editar" style="display:none"></button>
    </CardRh>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { Prop } from 'vue-property-decorator';
import CardRh from "@/components/cards/ManzaCard.vue";
import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
import KDataTable from "@/components/datatable/newdatatable.vue";
import SiteUtils from '@/assets/ts/aplicacao/site';
import { PerfilConfig } from "@/core/config/PerfisConfig";
import QtsSemanalDiaService from "@/service/v1/sigap/QtsSemanalDiaService";
import $ from "jquery";

@Options({
    name: "QtsSemanalDiaIndex",
    components: { CardRh, KDataTable, BotaoSalvar },
})
export default class QtsSemanalDiaIndex extends Vue {

    @Prop() readonly perfis!: any
    @Prop() readonly qtsSemanalId!: any

    public service = new QtsSemanalDiaService();
    public processando = false;
    public reloadDatatable = false;
    public config: any = null;
    public modal_editar = 'kt_qts_semanal_dia_editar';

    public novaData = '';
    public editId: any = null;
    public editData = '';

    get hasPermissaoEditar(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    private fmtData(v: any) {
        if (!v) return '';
        const s = String(v).substring(0, 10);
        const p = s.split('-');
        return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : s;
    }

    created() {
        this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => ({
                Skip: d.start,
                Take: d.length,
                qtsSemanalId: this.qtsSemanalId,
                search: d.search.value,
            })
        };
        this.config.order = [[1, 'asc']];
        this.config.columns = [
            { data: 'id', name: 'id' },
            { data: 'data', name: 'data' },
        ];
        this.config.columnDefs = [
            { targets: 1, render: (row) => this.fmtData(row) },
        ];
        if (this.hasPermissaoEditar) {
            this.config.columns.push({ data: 'id', name: 'id', orderable: false, searchable: false, class: 'text-center' });
            this.config.columnDefs.push({
                targets: 2,
                render: (row, type, val) => {
                    let buttom = '';
                    for (const key in val) { buttom = buttom + ' data-' + key + '="' + val[key] + '"'; }
                    let texto = '<button class="btn btn-success btn-sm me-1" btn-editar-dia ' + buttom + ' title="Editar"><i class="fa fa-edit"></i></button>';
                    texto += '<button class="btn btn-pmes-danger btn-sm" btn-excluir-dia ' + buttom + ' title="Excluir"><i class="fa fa-trash"></i></button>';
                    return texto;
                },
            });
        }
    }

    public refresh() {
        setTimeout(() => { this.reloadDatatable = !this.reloadDatatable; }, 300);
    }

    public adicionar() {
        if (this.processando || !this.hasPermissaoEditar) return;
        if (!this.novaData) { SiteUtils.toastErro('Erro!', 'Informe a data.'); return; }
        if (!this.qtsSemanalId) { SiteUtils.toastErro('Erro!', 'QTS Semanal não identificado.'); return; }
        this.processando = true;
        this.service.cadastrar({ qtsSemanalId: this.qtsSemanalId, data: this.novaData })
            .then(response => {
                SiteUtils.toastSucesso('Dia adicionado!', response?.message);
                this.novaData = '';
                this.processando = false;
                this.refresh();
            })
            .catch(error => {
                this.processando = false;
                SiteUtils.toastErro('Erro!', error?.data?.message);
            });
    }

    public tableatualizada() {
        $('[btn-editar-dia]').click((btn) => {
            const d = $(btn.currentTarget).data();
            this.editId = d.id;
            this.editData = d.data ? String(d.data).substring(0, 10) : '';
            (this.$refs.abrirEditar as HTMLElement).click();
        });
        $('[btn-excluir-dia]').click((btn) => {
            const id = $(btn.currentTarget).data('id');
            this.excluir(id);
        });
    }

    public salvarEdicao() {
        if (this.processando || !this.editId) return;
        if (!this.editData) { SiteUtils.toastErro('Erro!', 'Informe a data.'); return; }
        this.processando = true;
        this.service.update(this.editId, { id: this.editId, qtsSemanalId: this.qtsSemanalId, data: this.editData })
            .then(response => {
                SiteUtils.toastSucesso('Dia atualizado!', response?.message);
                this.processando = false;
                $("[data-bs-dismiss='modal']").trigger({ type: "click" });
                this.refresh();
            })
            .catch(error => {
                this.processando = false;
                SiteUtils.toastErro('Erro!', error?.data?.message);
            });
    }

    public excluir(id) {
        SiteUtils.alertConfimacao('Confirma a Exclusão', '',
            () => {
                this.processando = true;
                this.service.excluir(id)
                    .then(() => {
                        SiteUtils.toastSucesso('Exclusão realizada com sucesso!!');
                        this.processando = false;
                        this.refresh();
                    })
                    .catch(error => {
                        this.processando = false;
                        SiteUtils.toastErro('Não foi possível Excluir', error?.data?.message);
                    });
            }
        );
    }
}
</script>

<style scoped>
.qts-dia-page { display: grid; gap: 24px; }
.filter-panel, .table-panel {
    border: 1px solid #e5edf6; border-radius: 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%); padding: 15px;
}
.filter-panel { position: relative; padding-top: 24px; }
.panel-border-label {
    position: absolute; top: -9px; left: 18px; padding: 0 10px;
    background: #ffffff; color: #102542; font-size: 0.95rem; font-weight: 800;
}
.table-panel { padding: 2px 10px !important; }
.btn-sm { margin-left: 10px; }
</style>
